/**
 * Tiny event bus so pages outside GuidedTourProvider (dashboard button,
 * Restart tour controls) can launch a tour by slug.
 */

export const TOUR_START_EVENT = 'guided-tour:start';
export const TOUR_STATE_EVENT = 'guided-tour:state';

export function requestTourStart(slug) {
  if (!slug || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TOUR_START_EVENT, { detail: { slug } }));
}

export function publishTourState(state) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TOUR_STATE_EVENT, { detail: state }));
}
